export const professorPages = [
   [
          
            {
              src: require('@/assets/images/blankImg.png'), name:'שמואל', info:'', moreInfo: ''
            }
          ,
        
            {
              id: 6 , src: require('@/assets/images/blankImg.png'), name:'סבטלנה', info:'', moreInfo: 'blah blah blah'
            }
          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'יוסי', info:'', moreInfo: ''
            }
          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'נחמה', info:'', moreInfo: ''
            }
          ,
          
            {
               id: 9, src: require('@/assets/images/blankImg.png'), name:'רבקה', info:'', moreInfo: 'blaaaaaa'
            }

          ,
          
            {
               id: 10,src: require('@/assets/images/blankImg.png'), name:'גלית',  info:'', moreInfo: ' i hate shira'
            }
          ,
          
            {
               id: 11, src: require('@/assets/images/blankImg.png'), name:'יהודה',  info:'', moreInfo: 'kaki ktzina'
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'מיכה', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'רונית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'שרית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'יהודית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'מיכאל', info:'', moreInfo: ''
            }
          ,
            {
              id: 12, src: require('@/assets/images/blankImg.png'), name:'אלון', info:'', moreInfo: 'fuck you'
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'נעמי', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'שרה', info:'', moreInfo: ''
            }

    ],

    [
          
            {
              id:1, src: require('@/assets/images/blankImg.png'), name:'שרה', info:'', moreInfo: 'blahhh'
            }
          ,
        
            {
              src: require('@/assets/images/blankImg.png'), name:'שמוליק', info:'', moreInfo: ''
            }
          ,
          
            {
              id:2,src: require('@/assets/images/blankImg.png'), name:'יוסי', info:'', moreInfo: 'ad mataiiiii'
            }
          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'מוראל' ,info:'', moreInfo: ''
            }
          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'שושנה', info:'', moreInfo: ''
            }

          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'גלית', info:'', moreInfo: ''
            }
          ,
          
            {
              src: require('@/assets/images/blankImg.png'), name:'יהודה', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'מיכה', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'רונית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'שרית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'יהודית', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'מיכאל', info:'', moreInfo: ''
            }
          ,
            {
              src: require('@/assets/images/blankImg.png'), name:'אלון', info:'', moreInfo: ''
            }
          ,
            {
              id:3,src: require('@/assets/images/blankImg.png'), name:'נעמי', info:'', moreInfo: 'go fucking fuck urself'
            }
          
    ],
]